import { render, staticRenderFns } from "./jszlcjpdlc.vue?vue&type=template&id=6b1a0989&scoped=true&"
import script from "./jszlcjpdlc.vue?vue&type=script&lang=js&"
export * from "./jszlcjpdlc.vue?vue&type=script&lang=js&"
import style0 from "./jszlcjpdlc.vue?vue&type=style&index=0&id=6b1a0989&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1a0989",
  null
  
)

export default component.exports